const ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const FETCH_ISSUE_EXPRESS_REQUEST = 'FETCH_ISSUE_EXPRESS';

export const fetchIssueExpressPerf = {
	key: FETCH_ISSUE_EXPRESS_REQUEST,
	prefix: ISSUE_DETAILS_ANALYTICS_PREFIX,
} as const;
